// extracted by mini-css-extract-plugin
module.exports = {"findPeopleImage":"FindPeople_findPeopleImage__2zy7k","closeDiv":"FindPeople_closeDiv__2p45V"};